/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Source_AuthorInputs */

const en_editor_source_author = /** @type {(inputs: Editor_Source_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Author or channel`)
};

const de_editor_source_author = /** @type {(inputs: Editor_Source_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autor oder Kanal`)
};

/**
* | output |
* | --- |
* | "Author or channel" |
*
* @param {Editor_Source_AuthorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_source_author = /** @type {((inputs?: Editor_Source_AuthorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Source_AuthorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_source_author(inputs)
	return en_editor_source_author(inputs)
});